<template>
  <div>
    <input
      type="text"
      :value="value"
      @input="update($event.target.value)"
      class="input"
      @blur="isEmailValid($event.target.value)"
      :placeholder="placeholder"
    />
    <span v-if="isInvalidEmail" class="text-red text-sm"
      >Please enter a valid email!</span
    >
  </div>
</template>

<script>
export default {
  props: ["value", "placeholder"],
  data() {
    return {
      isInvalidEmail: false,
    };
  },
  methods: {
    update(value) {
      this.$emit("input", value);
    },
    isEmailValid(email) {
      //   console.log(email);
      const isValidEmail = this.validateEmail(email);
      if (!isValidEmail) {
        this.isInvalidEmail = true;
      } else {
        this.isInvalidEmail = false;
      }
    },
  },
};
</script>

<style></style>
